import * as React from 'react';
import './Gallery.scss';
import { Photo } from 'types';
import Lightbox from 'react-image-lightbox-rotate';
import 'react-image-lightbox/style.css';

export default class Gallery extends React.Component<{photos: Photo[]}, {
  isOpen: boolean, 
  currentImage: number, 
  docs: {src: string, name: string}[],
  images: {src: string}[]
}> {
  constructor(props: {photos: Photo[]}) {
    super(props);
    this.state = {
      isOpen: false,
      currentImage: 0,
      docs: props.photos.filter(obj => obj.mimetype.includes('application'))
                                          .map(doc => ({src: doc.url, name: doc.name})),
      images: props.photos.filter(obj => obj.mimetype.includes('image')).map(photo => ({src: photo.url}))
    };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
    
  }

  open(idx: number) {
    this.setState({isOpen: true, currentImage: idx});
  }

  close() {
    this.setState({isOpen: false});
  }

  next() {
    this.setState({currentImage: (this.state.currentImage + 1) % this.state.images.length});
  }

  prev() {
    this.setState({currentImage: (this.state.currentImage + this.state.images.length - 1) % this.state.images.length});
  }
  
  componentWillReceiveProps(newProps: {photos: Photo[]}) {
    this.setState({images: newProps.photos.filter(obj => obj.mimetype.includes('image'))
                                          .map(photo => ({src: photo.url}))});
  }

  render() {
    
    const { isOpen, images, docs, currentImage } = this.state;
    return (
      <div className="gallery">
        {images.map(({src}, idx) => (
          
          <img className="thumb" src={src} key={src} onClick={this.open.bind(this, idx)} />
        ))}
        {isOpen && (
          <Lightbox
            mainSrc={images[currentImage].src}
            nextSrc={images[(currentImage + 1) % images.length]}
            prevSrc={images[(currentImage + images.length - 1) % images.length]}
            onPreMovePrevRequest={this.prev}
            onPreMoveNextRequest={this.next}
            onCloseRequest={this.close}
          />
        )}
        <div>
        {docs.map(({src, name}, idx) => (
        <div key={src}>
            <a href={`${src}`} key={src}>{name}</a><br />
        </div>
        ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Gallery/index.tsx